<template>
  <div>
    <div class="resources-holder">
      <div class="resources-search-holder">
        <div class="rs-search">
          <div class="resources-caption">{{ Label }}</div>
          <div ref="searchBox" class="search-box">
            <input class="search-input" ref="searchInput" v-model.lazy="selected" type="text"
              :placeholder="'Select ' + Item.placeholder" @focus="$event.target.select()" @focusin="handleFocus"
              @blur="handleFocusOut" @select="true" @keyup="this.handleSearch()" />
              <!-- <img v-if="selected && Item.field != 'dealerLevel'" @click="handleSearchResultClick(null, $event)" style="margin-right: 10px; cursor: pointer;"  width="10" height="10" fill="black" :src="require('@/assets/svg/SVG/x.svg')"> -->
              <img :id="'dd-down-arrow-' + Item.field" class="dropdown-arrow-img"  width="12" height="12" fill="black" :src="require('@/assets/svg/SVG/down_arrow_blue.svg')">
          </div>
          <div ref="searchResults" v-if="SearchIsShowing && Options && InputType === this.$props.item.field"
            class="search-results">
            <div tabindex="0" class="search-result" v-for="result in getSearchResults"
              @click="handleSearchResultClick(result, $event)">
              <div>{{ result.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import gsap from 'gsap';

export default {
  props: [
    'options',
    'item',
    'inputType'
  ],
  data () {
    return {
      searchIsShowing: false,
      products: this.$props.options,
      selectedProduct: null,
      productResources: [],
    };
  },

  computed: {
    selected: {
      get () {
        if (this.Item.value != null) {
          return this.Item.value.name;
        }
      },
      set (newValue) {
        this.Item.value = newValue;
      },
    },
    SearchIsShowing () {
      return this.searchIsShowing;
    },
    InputType () {
      return this.$props.inputType;
    },
    Options () {
      return this.$props.options;
    },
    Item () {
      return this.$props.item;
    },
    Label () {
      return this.Item.label;
    },
    getSearchResults () {
      return this.products;
    },
  },

  methods: {
    handleFocus () {
      this.$emit('edit-type', this.Item.field);
      this.searchIsShowing = true;
      this.products = this.Options;
      this.$refs.searchBox.classList.add('focused');
      gsap.to('#dd-down-arrow-' + this.Item.field, {
        rotate: 180,
        transition: 0.1
      });
    },
    handleSearch () {
      let searchTxt = event.target.value.toLowerCase();

      // get the matching products
      this.products = this.Options.filter((product) => {
        return product.name.toLowerCase().includes(searchTxt);
      });
      if (searchTxt.length === 0) {
        this.$emit('dropdown-func', null, this.Item);
      }
      if (this.products.length > 0) {
        this.searchIsShowing = true;
      }
    },
    handleSearchResultClick (product, e) {
      this.$emit('dropdown-func', product, this.Item);
      this.handleFocusOut(e);
    },
    handleFocusOut (e) {
      gsap.to('#dd-down-arrow-' + this.Item.field, {
        rotate: 360
      });
      if (e.relatedTarget === null) {
        this.$data.searchIsShowing = false;
      }
      this.$refs.searchBox.classList.remove('focused');
    },
  }
};
</script>
<style scoped>
.resources {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.resources-holder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  /* margin-top: 30px;
  min-height: 300px; */
}

.resources-header {
  font-size: 18px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  line-height: 1.3;
  max-width: 800px;
}

.resources-search-holder {
  display: flex;
  width: 100%;
  height: 100%;
  /* max-width: 900px; */
}

.rs-search {
  flex: 1;
}

.rs-directions {
  flex: 0.8;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.resources-caption {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 2px;
}

.directions-title {
  text-align: center;
  font-weight: 900;
  font-size: 15px;
  margin-bottom: 10px;
}

.directions-step {
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 13px;
}

.bold {
  font-weight: bold;
}

.search-input {
  width: 100%;
  height: 100%;
  padding-left: 5px;
  border: none;
}

.search-input:focus,
.search-input:focus {
  outline: none;
}

.search-box {
  width: 80%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #b2b2b2;
}

.focused {
  border: 2px solid black;
  margin-left: -1px;
}

.icon-holder {
  width: 30px;
  height: auto;
  margin: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-results {
  width: 350px;
  position: absolute;
  background-color: #e1e1e1;
  box-shadow: 6px 6px 17px -2px rgba(0, 0, 0, 0.18);
  z-index: 1;
  max-height: 600px;
  overflow-y: auto;
}

.search-result {
  font-size: 15px;
  padding: 15px;
  background-color: white;
  cursor: pointer;
  border-bottom: 1px solid gray;
}

.search-result:hover {
  background-color: #efece0 !important;
}

@media only screen and (max-width: 900px) {
  .resources-holder {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }

  .resources-search-holder {
    flex-direction: column;
    margin-left: 20px !important;
    margin-right: 20px !important;
    width: 100%;
  }

  .search-box {
    width: 100%;
  }

  .directions-title {
    text-align: left;
    margin-top: 20px;
  }
}

.resources-sr-holder {
  width: 100%;
  background-color: #f7f6f1;
  display: flex;
  align-items: center;
  justify-content: center;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td,
th {
  border: 1px solid #ddd;
  padding: 8px;
  word-wrap: break-word;
  word-break: break-all;
}
.dropdown-arrow-img {
  margin-right: 10px;
    cursor: pointer;
}
</style>